import { Link } from 'react-router-dom';

import cx from 'classnames';

import { ArrowFullRightIcon } from '@motorway/mw-highway-code';

import { useReport } from '@motorway/motorway-handshake-components';

import { ROUTES } from '../../../helpers/routes';
import { snowplowClick } from '../../../helpers/snowplow';
import { PRICE_ADJUSTMENT_REASON_OPTIONS } from '../../../pages/Adjustment/Adjustment.helpers';
import { DAMAGE } from './ReportCardStatus.helpers';

import styles from './ReportCardStatus.module.scss';

export const ReportCardDamage = () => {
  const { report } = useReport();

  const { inspection } = report;
  const { damageTypes } = inspection;

  const reason = PRICE_ADJUSTMENT_REASON_OPTIONS.find(({ value }) => value === damageTypes)?.text;

  return (
    <h4 className={cx(styles.component, styles.arrow)}>
      <Link
        to={ROUTES.DAMAGE_REPORT}
        onClick={() => {
          snowplowClick({
            name: 'report_details_clicked',
            url: ROUTES.DAMAGE_REPORT,
          });
        }}
      >
        <span>
          {
            reason
              ? `${reason} found`
              : DAMAGE.ADDITIONAL_DAMAGE
          }
        </span>
        <ArrowFullRightIcon />
      </Link>
    </h4>
  );
};
